import { PopoverHeader, PopoverHeaderProps } from "@chakra-ui/react";

export interface FilterHeaderProps extends PopoverHeaderProps {}

export const FilterHeader = (props: FilterHeaderProps) => {
  return <PopoverHeader px={0} py={2} {...props} />;
};
